import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">
              Rafal Szelenc IT Services
            </h3>
            <p className="text-sm text-gray-600 mb-2">Rafal Jozef Szelenc</p>
            <p className="text-sm text-gray-600">SIRET : 102 261 021 00012</p>
          </div>

          <div>
            <h4 className="text-base font-semibold text-gray-900 mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-gray-900 mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-blue-600 mt-0.5"></i>
                <span className="text-sm text-gray-600">
                  73 Rue Fieux<br />31100 Toulouse<br />France
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-phone-line text-blue-600"></i>
                <a href="tel:+33605985260" className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                  +33 6 05 98 52 60
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-mail-line text-blue-600"></i>
                <a href="mailto:rafalszelenc@inbox.eu" className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                  rafalszelenc@inbox.eu
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-gray-900 mb-4">Informations légales</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/conditions-generales" className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                  Conditions générales
                </Link>
              </li>
              <li>
                <Link to="/politique-de-confidentialite" className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                  Politique de confidentialité
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-center text-sm text-gray-600">
            © 2025 Rafal Szelenc IT Services - Tous droits réservés
          </p>
        </div>
      </div>
    </footer>
  );
}